import { Component } from '@angular/core'
import { CmsOrderDetailOverviewComponent, TranslationService } from '@spartacus/core'
import { OrderDetailsService, OrderOverviewComponent } from '@spartacus/order/components'
import { Card, CmsComponentData } from '@spartacus/storefront'
import { Observable, combineLatest, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { CustomOrderHistoryService } from '../../../../services/order/custom-order-history.service'

@Component({
    selector: 'app-custom-order-overview',
    templateUrl: './custom-order-overview.component.html',
    styleUrls: ['./custom-order-overview.component.scss'],
    standalone: false
})
export class CustomOrderOverviewComponent extends OrderOverviewComponent {
  constructor(
    protected translation: TranslationService,
    protected orderDetailsService: OrderDetailsService,
    protected component: CmsComponentData<CmsOrderDetailOverviewComponent>,
    public customOrderHistoryService: CustomOrderHistoryService
  ) {
    super(translation, orderDetailsService, component)
  }

  getOrderStatusCardContent(status: string): Observable<Card> {
    return combineLatest([this.translation.translate('checkoutOrderConfirmation.status'), of(status)]).pipe(
      map(([textTitle, textStatus]) => ({
        title: textTitle,
        text: [textStatus]
      }))
    )
  }
  getPurchaseOrderNumber(poNumber: string): Observable<Card> {
    return combineLatest([
      this.translation.translate('checkoutShipping.poNumber'),
      this.translation.translate('shared.none')
    ]).pipe(
      map(([textTitle, noneTextTitle]) => {
        return {
          title: textTitle,
          text: [poNumber ? poNumber : noneTextTitle]
        }
      })
    )
  }
  getSpecialInstructions(specialInstructions: string): Observable<Card> {
    return combineLatest([
      this.translation.translate('checkoutShipping.specialInstructions'),
      this.translation.translate('shared.none')
    ]).pipe(
      map(([textTitle, noneTextTitle]) => {
        return {
          title: textTitle,
          text: [specialInstructions ? specialInstructions : noneTextTitle]
        }
      })
    )
  }
  getRequestedDeliveryDate(requestedDeliveryDate: string): Observable<Card> {
    return combineLatest([
      this.translation.translate('checkoutShipping.requestedDeliveryDate'),
      this.translation.translate('shared.none')
    ]).pipe(
      map(([textTitle, noneTextTitle]) => {
        return {
          title: textTitle,
          text: [requestedDeliveryDate ? requestedDeliveryDate : noneTextTitle]
        }
      })
    )
  }
  public removeNameFromCard(card: Card): Card {
    if (card && card.textBold) {
      delete card.textBold
    }
    return card
  }
}
